import Card from "@/components/common/Card";
import { SEGMENT_FIELDS } from "@/constants/segmentOptions";

const KIND_BITS = [
  { label: "Dynamic", bit: 1 },
  { label: "Overlay", bit: 2 },
  { label: "Banner", bit: 4 },
  { label: "Static", bit: 8 },
];

const GROUP_LABELS = {
  all: "Must match all",
  any: "Match any",
  none: "Exclude when",
};

const fieldLabel = (field) =>
  SEGMENT_FIELDS.find((f) => f.value === field)?.label ?? field;

const describeValue = (value) => {
  if (value === undefined || value === null || value === "") return "—";
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "object") return "schedule";
  return String(value);
};

export default function Step3Review({ form, updateField, onNumberChange }) {
  return (
    <Card className="builder-form flex flex-col gap-5">
      <div className="grid gap-4 md:grid-cols-2">
        <div className="form-group-modal">
          <label htmlFor="segment-cpm">CPM</label>
          <input
            id="segment-cpm"
            type="number"
            min="0"
            value={form.cpm ?? ""}
            onChange={(event) => onNumberChange("cpm", event.target.value)}
            placeholder="e.g. 100"
          />
        </div>
        <div className="form-group-modal">
          <label>Type</label>
          <div className="kind-picker">
            {KIND_BITS.map(({ label, bit }) => (
              <label key={bit} className="kind-checkbox">
                <input
                  type="checkbox"
                  checked={((form.kind ?? 15) & bit) !== 0}
                  onChange={() => updateField("kind", (form.kind ?? 15) ^ bit)}
                />
                {label}
              </label>
            ))}
          </div>
        </div>
      </div>

      <div className="builder-divider" aria-hidden />

      <div>
        <h3 className="text-base font-semibold text-(--text-primary)">
          Review targeting
        </h3>
        <p className="mt-1 text-sm text-(--text-secondary)">
          Double-check the rules before saving. Go back to adjust any step.
        </p>
        <div className="mt-4 flex flex-col gap-4">
          {["all", "any", "none"].map((group) => {
            const conditions = form.definition[group] ?? [];
            return (
              <div
                key={group}
                className="rounded-(--radius-md) border border-(--border-subtle) p-4"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="text-sm font-semibold text-(--text-primary)">
                    {GROUP_LABELS[group]}
                  </span>
                  <span className="text-xs text-(--text-muted)">
                    {conditions.length} condition
                    {conditions.length === 1 ? "" : "s"}
                  </span>
                </div>
                {conditions.length > 0 && (
                  <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm text-(--text-secondary)">
                    {conditions.map((condition) => (
                      <li
                        key={condition.id}
                        className={condition.disabled ? "line-through" : ""}
                      >
                        <span className="font-medium text-(--text-primary)">
                          {fieldLabel(condition.field)}
                        </span>{" "}
                        {condition.op} {describeValue(condition.value)}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
}
